import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

export let fromWhere: string;
@Component({
  selector: 'app-encrypted-login',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './encrypted-login.component.html',
  styleUrls: ['./encrypted-login.component.scss'],
})
export class EncryptedLoginComponent {
  @Output() closeMessage: EventEmitter<void> = new EventEmitter<void>();
  @Input() fromWhere = '';

  constructor(private router: Router) {}
  close(): void {
    this.closeMessage.emit();
  }

  routeToLogin(): void {
    fromWhere = this.fromWhere;
    this.router.navigateByUrl('/sifreli-depo/giris');
  }
}
